import { ReduxStore } from 'store/types';

function token(state: ReduxStore): string | null {
  return state.auth.authorization.token;
}

export default token;
